import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EditOrganisationLayer from "../components/EditOrganisationLayer";



const EditOrganisationPage = () => {
  
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Edit Organisation Page" />

        {/* ViewProfileLayer */}
        <EditOrganisationLayer />

      </MasterLayout>

    </>
  );
};

export default EditOrganisationPage; 